module.exports = __webpack_public_path__ + "static/media/token-eth.253d4683.svg";